import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=2000ef85&scoped=true"
import script from "./Loja.vue?vue&type=script&lang=js"
export * from "./Loja.vue?vue&type=script&lang=js"
import style0 from "./Loja.vue?vue&type=style&index=0&id=2000ef85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000ef85",
  null
  
)

export default component.exports